import { CommentMultipleOutlineIcon } from './CommentMultipleOutlineIcon';

/**
 * author: Austin Andrews
 * id A5FAC5DC-088F-485C-A885-FBBEEC70B352
 * name comment-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-multiple-outline.svg
 * tags
 */
export const CommentsOutlineIcon = CommentMultipleOutlineIcon;
export default CommentsOutlineIcon